import { ReactComponent as InfoIcon } from '../../images/Info.svg'
import {ReactComponent as YesIcon} from '../../images/icon-yes.svg'
import {ReactComponent as NoIcon} from '../../images/icon-no.svg'

export const InfoIconSVG = InfoIcon
export const YesIconSVG = YesIcon
export const NoIconSVG = NoIcon